module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-60x60287a32f73b06e2e2cd4b878acb3ba010.png";